import {
    Component, EventEmitter, Input, Output,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { OverlayContext } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CommonHttpService } from '../../../../../shared/services/http.service';
import { SubscriptionModel } from '../../../../../shared/models/payment/subscription/subscription.model';
import { ClientModel } from '../../../../../shared/models/client.model';
import { AddressModel } from '../../../../../shared/models/address.model';
import { ZipCodeRangeModel } from '../../../../../shared/models/zip-code-range.model';
import { Response } from '@angular/http';

@Component({
    selector: 'account-subscriptions-details-actions-address',
    templateUrl: './account.subscriptions.details.actions.address.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsAddressComponent {
    @ViewChild('templateRef') public templateRef: TemplateRef<any>;
    @Input('subscription') subscription: SubscriptionModel;
    @Input('client') client: ClientModel;
    @Output('updated') updated: EventEmitter<any> = new EventEmitter();

    protected overlayContext = new OverlayContext();
    public loading = false;
    public loadingFreights = false;
    public addresses: Array<AddressModel> = [];
    public freights: Array<ZipCodeRangeModel> = [];
    public selectedAddress: AddressModel = null;
    public selectedFreight: ZipCodeRangeModel = null;
    public requestConfirmation = false;
    public confirmed = false;

    constructor(
        protected modal: Modal,
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected toastr: ToastrService
    ) {
        this.overlayContext.inElement = false;
        this.overlayContext.isBlocking = true;
        this.overlayContext.keyboard = null;
    }

    public openDialog() {
        this.loading = true;
        this.modal
            .open(this.templateRef, {context: this.overlayContext})
            .then(() => {
                this.reset();
                this.http.useAuth().get(
                    `/account/clients/${this.client.id}/addresses?_sort=-updated_at&_limit=5`
                ).subscribe((res: Response) => {
                    this.addresses = res.json().data;
                    this.loading = false;
                });
            });
    }

    public closeDialog(dialogRef: any) {
        this.reset();
        dialogRef.close();
    }

    public setAddress(address: AddressModel) {
        this.selectedAddress = address;
        this.selectedFreight = null;
        this.freights = [];
        this.requestConfirmation = false;
        this.confirmed = false;
        this.loadFreights(address.zip_code);
    }

    public setFreight(freight: ZipCodeRangeModel) {
        this.selectedFreight = freight;
        this.requestConfirmation = false;
        this.confirmed = false;
    }

    public isSelectedAddress(address: AddressModel): boolean {
        return this.selectedAddress !== null && this.selectedAddress.id === address.id;
    }

    public isSelectedFreight(freight: ZipCodeRangeModel): boolean {
        return this.selectedFreight !== null && this.selectedFreight.id === freight.id;
    }

    public save(dialogRef: any) {
        if (!this.confirmed && !this.requestConfirmation) {
            this.requestConfirmation = true;
            return;
        }

        this.loading = true;
        this.confirmed = true;
        this.http.useAuth().put(
            `/account/clients/${this.client.id}/subscriptions/${this.subscription.id}`,
            {
                delivery: {
                    address_id: this.selectedAddress.id,
                    zip_code_range_id: this.selectedFreight.id
                }
            }
        ).subscribe(() => {
            this.translate
                .get('ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.UPDATE_ADDRESS_MODAL.SUCCESS')
                .subscribe(message => {
                    this.loading = false;
                    this.toastr.success(message);
                    this.closeDialog(dialogRef);
                    this.updated.emit();
                });
        }, () => {
            this.translate
                .get('ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.UPDATE_ADDRESS_MODAL.ERROR')
                .subscribe(message => {
                    this.confirmed = false;
                    this.requestConfirmation = false;
                    this.loading = false;
                    this.toastr.error(message);
                });
        });
    }

    private loadFreights(zipCode: string) {
        this.loadingFreights = true;
        this.http.get(
            `/ecommerce/zip-code-ranges?zip_code=${zipCode.replace(/\D/g, '')}`
        ).subscribe((res: Response) => {
            this.freights = res.json().data;
            this.loadingFreights = false;
        }, () => {
            this.loadingFreights = false;
            this.translate
                .get('ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.UPDATE_ADDRESS_MODAL.FREIGHTS_ERROR')
                .subscribe(message => this.toastr.error(message));
        });
    }

    private reset() {
        this.addresses = [];
        this.freights = [];
        this.selectedAddress = null;
        this.selectedFreight = null;
        this.requestConfirmation = false;
        this.confirmed = false;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/account/subscriptions/details/actions/address/account.subscriptions.details.actions.address.component.ts